module.exports = __webpack_public_path__ + "img/ic-map-list-all.0a0638a1.svg";